export enum ColorType {
  OperationalModules = 'operational-modules',
  Demand = 'demand',
  Resources = 'resources',
  Places = 'places',
}
